module.exports = __webpack_public_path__ + "img/marker-vermelho.033cec10.svg";